import UpdateExportCnfBill from "./Update";

export default function ViewExportCnfBill(props) {
  return <UpdateExportCnfBill {...props} viewMode />;
}
